export * from "./sygic.custom.url.service";



// WEBPACK FOOTER //
// ./src/index.ts